import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "../lib/apiBase";

const API = `${BACKEND_URL}/api`;

const FALLBACK = { max_drawdown: -1.42 };

export const useTrackMeta = () => {
  const [meta, setMeta] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/track-meta`)
      .then((res) => {
        if (!cancelled && res.data) setMeta({ ...FALLBACK, ...res.data });
      })
      .catch(() => {})
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  return { meta, loading };
};
